/**
 * @generated SignedSource<<016f7d7742dfa02e809f6d0bab827e29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EventInviteCodeRemoveMutation$variables = {
  id: string;
};
export type EventInviteCodeRemoveMutation$data = {
  readonly removeEventInviteCode: {
    readonly code: string | null | undefined;
    readonly id: string;
  };
};
export type EventInviteCodeRemoveMutation = {
  response: EventInviteCodeRemoveMutation$data;
  variables: EventInviteCodeRemoveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "EventPublicInvite",
    "kind": "LinkedField",
    "name": "removeEventInviteCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventInviteCodeRemoveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventInviteCodeRemoveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ee58baac912300a6e4a2e68aeca2ceeb",
    "id": null,
    "metadata": {},
    "name": "EventInviteCodeRemoveMutation",
    "operationKind": "mutation",
    "text": "mutation EventInviteCodeRemoveMutation(\n  $id: ID!\n) {\n  removeEventInviteCode(id: $id) {\n    id\n    code\n  }\n}\n"
  }
};
})();

(node as any).hash = "a8c01f953667cd4a8be25b69aa086953";

export default node;
